(() => {
  'use strict';
  if (window.__TKBScannerEventsV1) return;
  window.__TKBScannerEventsV1 = true;

  const params = new URLSearchParams(window.location.search);
  const attribution = {
    path: window.location.pathname,
    source: params.get('utm_source') || '',
    medium: params.get('utm_medium') || '',
    campaign: params.get('utm_campaign') || '',
    content: params.get('utm_content') || '',
    term: params.get('utm_term') || ''
  };

  const sent = new Set();
  const publish = (name, extra = {}, onceKey = '') => {
    const key = onceKey || name;
    if (sent.has(key)) return;
    const fn = window.Shopify?.analytics?.publish;
    if (typeof fn !== 'function') return;
    sent.add(key);
    try {
      const result = fn(name, {...attribution, ...extra});
      if (result && typeof result.catch === 'function') result.catch(() => sent.delete(key));
    } catch (_) {
      sent.delete(key);
    }
  };

  if (window.location.pathname === '/pages/proof') {
    publish('tkb:client_proof_view', {offer: 'Client Proof'}, 'client-proof-view');
  }

  if (window.location.pathname === '/pages/solutions') {
    publish('tkb:solutions_view', {offer: 'Solutions'}, 'solutions-view');
  }

  if (window.location.pathname === '/pages/free-growth-tools') {
    publish('tkb:free_tools_landing_view', {offer: 'Free Growth Tools'}, 'free-tools-view');
    document.addEventListener('click', (event) => {
      const link = event.target.closest('a[href*="#snapshot"],a[href*="#business-audit"],a[href*="#ad-leak-scan"]');
      if (!link) return;
      let tool = 'unknown';
      const href = link.getAttribute('href') || '';
      if (href.includes('#snapshot')) tool = 'growth_snapshot';
      else if (href.includes('#business-audit')) tool = 'business_audit';
      else if (href.includes('#ad-leak-scan')) tool = 'ad_leak_scan';
      publish('tkb:free_tools_tool_click', {
        offer: 'Free Growth Tools',
        tool,
        destination: href
      }, 'free-tools-click-' + tool);
    });
  }

  const watchVisible = (rootSelector, resultSelector, eventName, extraBuilder) => {
    document.querySelectorAll(rootSelector).forEach((root, index) => {
      const result = root.querySelector(resultSelector);
      if (!result) return;
      const fire = () => {
        if (result.hidden) return;
        publish(eventName, extraBuilder(root), eventName + '-' + index);
      };
      fire();
      new MutationObserver(fire).observe(result, {attributes: true, attributeFilter: ['hidden']});
    });
  };

  document.addEventListener('submit', (event) => {
    if (event.target.matches('[data-tkb-snapshot-v2-form]')) {
      publish('tkb:growth_snapshot_started', {tool: 'growth_snapshot'}, 'growth-start');
    }
    if (event.target.matches('[data-ad-leak-form]')) {
      publish('tkb:ad_leak_scan_started', {tool: 'ad_leak_scan'}, 'ad-leak-start');
    }
    if (event.target.matches('.tkb-report-share')) {
      publish('tkb:scanner_lead_submit', {tool: 'growth_snapshot', action: 'send_report'}, 'growth-lead');
    }
    if (event.target.matches('[data-ad-leak-contact]')) {
      publish('tkb:scanner_lead_submit', {tool: 'ad_leak_scan', action: 'send_assessment'}, 'ad-leak-lead');
    }
    if (event.target.closest('[data-tkb-audit-result]') || event.target.matches('form[action*="/contact"]') && event.target.querySelector('[name="contact[request_type]"][value*="Business Readiness"]')) {
      publish('tkb:scanner_lead_submit', {tool: 'business_audit', action: 'send_assessment'}, 'business-lead');
    }
  }, true);

  document.addEventListener('click', (event) => {
    const detail = event.target.closest('[data-tkb-offer-detail]');
    if (detail) publish('tkb:solution_detail_open', {offer: detail.dataset.offer || 'unknown'}, 'solution-detail-' + (detail.dataset.offer || 'unknown'));

    const recommendation = event.target.closest('.tkb-scanner-rec-link,[data-ad-leak-findings] a[href*="/products/"],[data-ad-leak-growth-options] a[href*="/products/"]');
    if (recommendation) publish('tkb:scanner_recommendation_click', {destination: recommendation.getAttribute('href') || '', label: recommendation.textContent.trim()}, 'scanner-rec-' + (recommendation.getAttribute('href') || recommendation.textContent.trim()));

    const answer = event.target.closest('[data-tkb-audit-question] button[data-score]');
    if (answer) publish('tkb:business_audit_started', {tool: 'business_audit'}, 'business-start');
  }, true);

  watchVisible('[data-tkb-scanner-v2="website"]', '[data-tkb-report]', 'tkb:growth_snapshot_complete', (root) => ({
    tool: 'growth_snapshot',
    score: Number(root.querySelector('[data-tkb-report-score]')?.textContent) || null,
    confidence: root.tkbReport?.confidence || null
  }));

  watchVisible('[data-tkb-scanner-v2="business"]', '[data-tkb-audit-result]', 'tkb:business_audit_complete', (root) => ({
    tool: 'business_audit',
    score: Number(root.querySelector('[data-tkb-audit-score]')?.textContent) || null
  }));

  watchVisible('[data-ad-leak-scan]', '[data-ad-leak-report]', 'tkb:ad_leak_scan_complete', (root) => ({
    tool: 'ad_leak_scan',
    score: Number(root.querySelector('[data-ad-leak-score]')?.textContent) || null,
    confidence: root.tkbAdLeakReport?.confidence || null
  }));
})();
